@if (treatment$ | async; as treatment) {
  <pr-charted-item-card-v2
    #card="prChartedItemCardV2"
    [expanded]="expanded"
    [item]="treatment"
    [selectedSurfaces]="selectedSurfaces$ | async"
    [disabled]="disabled"
    [compact]="compact"
    [flat]="isNested()"
    [minimal]="isNested()"
    [plan]="plan$ | async"
    (itemChange)="treatmentChange($event)"
    (itemDelete)="deleteTreatment($event)"
    (updateChartable)="updateChartable.emit($event)"
  >
    <ng-container ngProjectAs=".drag-handle">
      <ng-content select=".drag-handle" />
    </ng-container>

    <ng-container ngProjectAs=".deposit-indicator">
      @if (deposit$ | async; as deposit) {
        <pr-timeline-deposit-notification
          [deposit]="deposit"
          [tooltipsEnabled]="true"
        />
      }
    </ng-container>

    <ng-container
      *ngIf="serviceCodeSummary$ | async as serviceCodeSummary"
      ngProjectAs=".header-info"
    >
      <small
        class="mat-caption truncate text-gray-500"
        matTooltipShowDelay="300"
        [matTooltip]="'Service Codes: ' + serviceCodeSummary"
      >
        {{ serviceCodeSummary }}
      </small>
    </ng-container>

    <ng-container ngProjectAs=".menu-buttons">
      <button
        mat-menu-item
        [disabled]="disabled"
        (click)="addBasePrice(treatment)"
      >
        <mat-icon>price_check</mat-icon>
        Set Base Treatment Price
      </button>
    </ng-container>

    <ng-container ngProjectAs=".category-indicator">
      <pr-treatment-category-indicator
        [category]="treatmentCategory$ | async"
        (categoryChanged)="categoryChanged.emit($event)"
      />
    </ng-container>

    <ng-container ngProjectAs=".attributed-to">
      <pr-assignee-profile-selector
        selectTooltip="Override Treatment Provider"
        [disabled]="disabled"
        [clearTooltip]="clearTooltip$ | async"
        [staff]="organisation.brandPractitioners$ | async"
        [selectedStaffer]="treatment.attributedTo?.ref"
        (stafferSelected)="setAttributedTo($event)"
      />
    </ng-container>

    <ng-container ngProjectAs=".change-fee-schedule">
      <pr-staff-fee-schedule-menu
        [disabled]="disabled"
        [feeSchedule]="feeSchedule$ | async"
        [plan]="plan$ | async"
        [patient]="patient$ | async"
        (scheduleSelected)="setFeeSchedule($event)"
      />
    </ng-container>

    <ng-container
      *ngrxLet="treatmentPackages$ as packages"
      ngProjectAs=".change-treatment-package"
    >
      <pr-treatment-package-menu
        [packages]="packages"
        [currentPackageId]="treatment.treatmentPackageId"
        (packageSelected)="setTreatmentPackage($event, packages, treatment)"
      />
    </ng-container>

    <ng-container ngProjectAs=".checkbox">
      <pr-charted-item-toolbar
        [disabled]="disabled"
        [item]="treatment"
        [step]="step$ | async"
        [plan]="plan$ | async"
      />
    </ng-container>

    <ng-container *ngIf="card.collapsible?.expanded">
      <div class="body-content flex flex-col gap-1">
        <pr-edit-base-price
          *ngIf="treatment | map: hasBasePrice$ : this | async"
          compact
          name="Treatment Base Price"
          class="mx-2"
          [price]="treatment.basePrice ?? 0"
          [priceOverride]="treatment.basePriceOverride"
          [pricingRule]="treatment.basePricePricingRule"
          [disabled]="disabled"
          [feeSchedule]="feeSchedule$ | async"
          [config]="config$ | async"
          (priceOverrideChange)="updateBasePriceOverride($event)"
          (pricingRuleChange)="updateBasePricePricingRule($event)"
          (resetToFeeSchedule)="resetToFeeSchedule()"
          (basePriceDeleted)="deleteBasePrice(treatment)"
        />

        @if (treatment.serviceCodeSmartGroups?.length) {
          <pr-service-item-smart-group-list
            [chartedSurfaces]="treatment.chartedSurfaces"
            [groups]="treatment.serviceCodeSmartGroups"
            [disabled]="disabled"
            [compact]="compact"
            (groupsChange)="updateSmartGroups(treatment, $event)"
          />
        }

        @if (treatment.serviceCodeGroups?.length) {
          <pr-service-item-exclusive-group-list
            [scope]="treatment.scopeRef"
            [chartedSurfaces]="treatment.chartedSurfaces"
            [groups]="treatment.serviceCodeGroups"
            [disabled]="disabled"
            (groupsChange)="updateExclusiveGroups($event, treatment)"
          />
        }

        <pr-service-item-list
          [stepTreatments]="step$ | map: getStepTreatments$ | async"
          [chartedItem]="treatment"
          [serviceCodes]="treatment.serviceCodes"
          [disabled]="disabled"
          [feeSchedule]="treatment.feeSchedule"
          [compact]="compact"
          [treatmentConfig]="config$ | async"
          (itemsChange)="updateServiceCodes(treatment, $event)"
        />

        <pr-charted-item-notes-list
          [item]="treatment"
          (itemChange)="treatmentChange($event)"
        />
      </div>
    </ng-container>
  </pr-charted-item-card-v2>
}
